import React from 'react';
import { strings } from '../constants/strings';
import { colors } from '../constants/colors';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand" onClick={scrollToTop} style={{ cursor: 'pointer' }}>
              <div className="footer-logo-container">
                <img src="/logo.png" alt="CodeOrigin" className="footer-logo" />
              </div>
            </div>
            <h3 className="footer-tagline">{strings.footer.tagline}</h3>
            <p className="footer-positioning">{strings.footer.positioning}</p>
          </div>
          
          <div className="footer-links">
            <button onClick={() => scrollToSection('services')}>Services</button>
            <button onClick={() => scrollToSection('portfolio')}>Portfolio</button>
            <button onClick={() => scrollToSection('contact')}>Contact</button>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} {strings.company.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
